module.exports = __webpack_public_path__ + "static/thpcminthamper1-33e39a5e7a5e167e8b81e472b0fe6651.jpeg";